<template>
  <div>
    <div class="scan-pay-code-wrap">
      <div class="scan-info">
        <div class="user-info flex">
          <div>{{ orderData.student_name }}</div>
          <div class="border">|</div>
          <div>{{ orderData.student_mobile }}</div>
        </div>
        <div class="amount flex">
          <div>现付金额：</div>
          <div>{{ Number(orderData.amount).toFixed(2) }}</div>
        </div>
      </div>
      <div class="step-wrap" v-if="step === 1">
        <div class="icon-wrap flex">
          <img
            class="border-icon"
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/finance/pay/scan-border.png"
          />
          <img
            class="scan-line"
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/finance/pay/scan-line.png"
          />
        </div>

        <p class="title">等待客户扫码支付</p>
      </div>
      <div class="step-wrap" v-if="step === 2">
        <img
          class="icon"
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/finance/pay/lock-success.png"
        />

        <div v-if="!payCheckTimeout">
          <p class="title">
            扫码成功，正在查询支付状态，<br />请耐心等待
            <i class="el-icon-loading"></i>
          </p>
          <p class="tips" v-show="needPassword">（需要客户输入密码）</p>
        </div>
        <div v-else>
          <p class="title">
            暂未查询到最新的支付状态<br />
            请手动刷新查询
          </p>
          <div class="button-wrap">
            <div
              class="mwow-button-filled"
              style="min-width: 72px"
              :class="{
                info: handCheckFinishCD > 0,
                success: handCheckFinishCD === 0,
              }"
              @click="checkOrderPayStatus"
            >
              {{
                handCheckFinishCD > 0
                  ? "手动刷新(" + handCheckFinishCD + ")s"
                  : "手动刷新"
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="step-wrap" v-if="step === 3">
        <img
          class="icon"
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/finance/pay/pay-success.png"
        />

        <p class="title">支付成功</p>
        <div class="button-wrap">
          <div class="mwow-button-filled success" @click="emitHideDialog">
            查看订单
          </div>
        </div>
      </div>
      <div class="step-wrap" v-if="step === 4">
        <img
          class="icon"
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/finance/pay/time-error.png"
        />

        <p class="title">二维码不是有效支付码，请扫描<br />正确的支付码</p>
        <div class="button-wrap">
          <div class="mwow-button-filled success" @click="listeningScan">
            扫客户码重新支付
          </div>
        </div>
      </div>
      <div class="step-wrap" v-if="step === 5">
        <img
          class="icon"
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/finance/pay/pay-error.png"
        />

        <p class="title">支付失败</p>
        <div class="button-wrap">
          <div class="mwow-button-filled success" @click="listeningScan">
            扫客户码重新支付
          </div>
        </div>
      </div>
      <div class="scan-bottom flex">
        <div>
          <img
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/studying/wechat.png"
            alt=""
          />
        </div>
        <div>
          <img
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/studying/alipay.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- 审批提示弹窗 -->
    <approve-tips-dialog
      :visible.sync="approveDialogVisible"
      :order-id="orderData.order_id"
      @close="emitHideDialog"
    ></approve-tips-dialog>
  </div>
</template>
<script>
import { checkFinishApi, changePaymentTypeApi } from "@/api/order";
import approveTipsDialog from "@/components/approveTipsDialog.vue";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderData: {
      type: Object,
      default: function () {
        return {
          order_id: 0,
          payment_methods: [],
        };
      },
    },
  },
  components: {
    approveTipsDialog,
  },
  data() {
    return {
      step: 1,
      dialogVisible: false,
      scanFinishTimer: null, // 扫描节流计时器
      inputFocusTimer: null, // input的定时聚焦
      needPassword: false,
      payErrorMessage: "",
      paymentDialogVisible: false,
      approveDialogVisible: false,
      payCheckTimeout: false, // 查询订单状态超时，改为手动查询
      handCheckFinishCD: 0, // 手动刷新订单状态的CD
      orderPaymentId: 0, // 支付记录ID，用来查询支付状态
    };
  },
  created() {
    // 切换支付方式时,取消掉上次的收款机扫码
    this.cancelListeningScan();
    this.listeningScan();
  },
  methods: {
    // 监听扫码机传入code，是一个input事件
    listeningScan() {
      this.step = 1;
      let el = document.createElement("input");
      el.id = "hidden-code-input";
      el.style.opacity = "0";
      el.style.height = "0px";
      el.style.width = "0px";
      el.style.position = "fixed";
      el.style.zIndex = "0";
      el.addEventListener("input", (e) => {
        clearTimeout(this.scanFinishTimer);
        clearInterval(this.inputFocusTimer);
        this.scanFinishTimer = setTimeout(() => {
          this.handleScanFinish(el.value);
          el.remove();
        }, 500);
      });
      document.body.appendChild(el);
      this.inputFocusTimer = setInterval(() => {
        el.focus();
      }, 100);
    },
    cancelListeningScan() {
      let el = document.getElementById("hidden-code-input");
      if (el) {
        el.remove();
      }
      clearTimeout(this.scanFinishTimer);
      clearInterval(this.inputFocusTimer);
    },
    handleScanFinish(code) {
      // 判断是否为支付码，纯数字小于等于32
      if (!/^\d{1,32}$/.test(code)) {
        this.step = 4;
        return false;
      }
      this.step = 2;
      // 请求changePaymentTypeApi获取order_payment_id
      changePaymentTypeApi({
        order_id: this.orderData.order_id,
        payment_methods: this.orderData.payment_methods,
        auth_code: code,
      }).then((cpRes) => {
        this.orderPaymentId = cpRes.data.order_payment_id;
        if (cpRes.error_code === 0) {
          this.needPassword = cpRes.data.micro_pay_need_query;
          // 扫码完成，轮询订单支付状态
          this.loopOrderPayStatus(new Date().getTime(), 0);
        } else if (cpRes.error_code === 21016024) {
          this.step = 4;
        } else {
          this.step = 5;
          this.payErrorMessage = cpRes.message;
        }
      });
    },
    // 手动刷新订单状态
    checkOrderPayStatus() {
      if (this.handCheckFinishCD > 0) {
        return false;
      }
      this.handCheckFinishCD = 5;
      checkFinishApi({
        order_payment_id: this.orderPaymentId,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "刷新成功",
        });
        if (res.data.payment_status === 3) {
          this.step = 3;
        }
        if (res.data.payment_status === 2) {
          this.step = 5;
        }
      });
      let timer = setInterval(() => {
        let now = this.handCheckFinishCD - 1;
        this.handCheckFinishCD = now;
        if (now === 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    // 轮询查询订单是否被支付，一分钟后结束轮询，前6次间隔5秒，后续间隔10秒
    loopOrderPayStatus(start, total) {
      checkFinishApi({
        order_payment_id: this.orderPaymentId,
      })
        .then((res) => {
          if (res.data.payment_status === 1) {
            if (new Date().getTime() - start < 60000) {
              setTimeout(
                () => {
                  this.loopOrderPayStatus(start, total + 1);
                },
                total < 6 ? 5000 : 10000
              );
            } else {
              // 轮询结束，改为手动查询
              this.payCheckTimeout = true;
            }
          }
          if (res.data.payment_status === 3) {
            this.step = 3;
          }
          if (res.data.payment_status === 2) {
            this.step = 5;
          }
        })
        .catch(() => {
          this.payCheckTimeout = true;
        });
    },
    // 关闭全部弹窗
    emitHideDialog() {
      this.cancelListeningScan();
      this.dialogVisible = false;
      this.paymentDialogVisible = false;
      this.approveDialogVisible = false;
      this.$emit("update:visible", false);
      this.$emit("close");
      // 弹窗关闭后自动跳去订单详情
      if (this.$route.name !== "orderManageDetail") {
        this.toOrderDetail();
      }
    },
    toOrderDetail() {
      this.$router.push({
        name: "orderManageDetail",
        query: {
          id: String(this.orderData.order_id),
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.scan-pay-code-wrap {
  width: 300px;
  background: url("https://wowsite.musicwow.com/teaching_system_frontend/images/studying/codebg2x.png")
    no-repeat;
  background-size: contain;
  .scan-info {
    margin: 45px 40px;
    font-size: 12px;
    color: rgba(92, 93, 94, 1);
    .user-info {
      margin-bottom: 13px;
      justify-content: center;
      .border {
        margin: 0 8px;
        color: rgba(151, 151, 151, 1);
      }
    }
    .amount {
      justify-content: center;
      color: rgba(92, 93, 94, 1);
      div {
        font-size: 14px !important;
        font-weight: 700 !important;
      }
      &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
    }
  }
  .step-wrap {
    text-align: center;
    .icon-wrap {
      border: 1px solid rgba(218, 218, 218, 1);
      border-radius: 10px;
      width: 156px;
      height: 156px;
      position: relative;
      margin: 0 auto;
      justify-content: center;
      background: white;
      .border-icon {
        width: 127px;
        height: 127px;
        text-align: center;
        line-height: 127px;
      }
      .scan-line {
        position: absolute;
        top: 33px;
        left: 15px;
        width: 126px;
        height: 4px;
        animation: move 1s infinite linear alternate;
      }
    }
    .icon {
      // width: 80px;
      // height: auto;
      width: 156px;
      height: 156px;
      border: 1px solid rgba(218, 218, 218, 1);
      border-radius: 10px;
    }
    .title {
      font-size: 16px;
      line-height: 24px;
      font-weight: bold;
      color: #5c5d5e;
      // margin-bottom: 38px;
      margin: 18px 0 12px 0;
    }
    .tips {
      font-size: 12px;
      color: #666;
      margin-bottom: 12px;
    }
    .desc {
      font-size: 13px;
      line-height: 20px;
      color: #5c5d5e;
      margin-bottom: 12px;
      .red {
        color: #f56e6e;
      }
    }
    .radio-wrap {
      margin: 12px 0;
      /deep/.el-radio {
        display: block;
        text-align: left;
        margin-top: 12px;
        margin-right: 0;
        .el-radio__input {
          .el-radio__inner {
            &:hover {
              border-color: #07d1aa;
            }
          }
          &.is-checked {
            .el-radio__inner {
              background-color: #07d1aa;
              border-color: #07d1aa;
            }
          }
        }
        .el-radio__label {
          font-size: 13px !important;
          color: #5c5d5e !important;
        }
      }
    }
    .button-wrap {
      margin-bottom: 8px;
      .mwow-button-filled {
        margin: 0 5px;
      }
    }
  }
  .scan-bottom {
    width: 100%;
    justify-content: space-evenly;
    margin: 12px 0 24px 0;
    div {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      line-height: 16px;
      background-color: #fff;
      border: 0.86px solid rgba(230, 230, 230, 1);
      img {
        width: 100%;
      }
    }
  }
}

@keyframes move {
  from {
    top: 33px;
  }
  to {
    top: 118px;
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
